import { render, staticRenderFns } from "./ObservacoesList.vue?vue&type=template&id=27d9ddef&"
import script from "./ObservacoesList.vue?vue&type=script&lang=ts&"
export * from "./ObservacoesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports